
import React from 'react';
import { ChevronDown } from 'lucide-react';
import { useIsMobile } from '@/hooks/use-mobile';

interface HeaderSectionProps {
  title: string;
  subtitle?: string;
  className?: string;
}

const HeaderSection: React.FC<HeaderSectionProps> = ({ title, subtitle, className }) => {
  const isMobile = useIsMobile();

  return (
    <div className={`pt-12 mb-10 text-center ${className || ''}`}>
      <h2 className="text-2xl font-bold mb-2">{title}</h2>
      {subtitle && <p className="text-gray-600">{subtitle}</p>}
      
      {isMobile && (
        <div className="mt-2 mb-4 flex justify-center animate-bounce">
          <ChevronDown className="text-gray-500 w-6 h-6" />
        </div>
      )}
    </div>
  );
};

export default HeaderSection;
